module.exports = __webpack_public_path__ + "static/media/MuleDeer.svg";